import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'
import type { AdminTaskResponse } from '../services'

export const useQueryAdminTasks = (roomId: string, enabled = true) => {
	return useQuery<AdminTaskResponse[]>({
		queryKey: chatKeys.adminTasks(roomId),
		queryFn: () => chatService.getRoomAdminTasks(roomId),
		enabled: enabled && !!roomId,
		staleTime: 30 * 1000,
	})
}
